import React from 'react';
import './maintenance.css';

export default function MaintenancePage({ title = "We're currently undergoing Maintenance!", message = "We'll be back shortly. Thank you for your patience!", detail = "If you have any urgent inquiries, please contact support." }) {
  return (
    <div className="maintenance-shell">
      <div className="maintenance-container">
        <div className="message-box">
          <h1>{title}</h1>
          <p className="lead">{message}</p>
          <p className="muted">{detail}</p>
        </div>
      </div>
    </div>
  );
}
